import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67fc5ea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "正在检测，请勿关闭当前页面", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MicroVideo = _resolveComponent("MicroVideo")!
  const _component_MicroPhone = _resolveComponent("MicroPhone")!
  const _component_Countdown = _resolveComponent("Countdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MicroVideo, {
      stream: _ctx.mediaService.stream
    }, null, 8, ["stream"]),
    _createVNode(_component_MicroPhone, { ready: _ctx.ready }, null, 8, ["ready"]),
    _createVNode(_component_Countdown, {
      time: _ctx.countdownService.current
    }, null, 8, ["time"]),
    _hoisted_2
  ]))
}